import { useState } from "react";

export default function Accordion({ items }) {
  const [openId, setOpenId] = useState(items[0]?.id ?? null);

  return (
    <div className="space-y-3">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <article key={item.id} className="rounded-2xl border border-white/60 bg-white/80 shadow-lg backdrop-blur">
            <button
              type="button"
              aria-expanded={open}
              aria-controls={`panel-${item.id}`}
              className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left font-semibold text-slate-800 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-pink-200"
              onClick={() => setOpenId(open ? null : item.id)}
            >
              <span>{item.question}</span>
              <span className="text-xl text-slate-500">{open ? "−" : "+"}</span>
            </button>
            {open ? (
              <div id={`panel-${item.id}`} className="px-4 pb-4 text-slate-600">
                {item.answer}
              </div>
            ) : null}
          </article>
        );
      })}
    </div>
  );
}
